import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const HeaderContainer = styled.div`
  position: relative;
  z-index: 10;

  ${breakpoint('tablet')`
    width: 100%;
    padding-top: 55%;
    height: 0;
    overflow: hidden;
  `}
`

const ImageContainer = styled.div`
  position: absolute;
  z-index: -2;

  ${breakpoint('tablet')`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: fill;
  `}

  picture, img {
    display: block;
    margin: 0;

    ${breakpoint('tablet')`
      object-fit: fill;
      width: 100%;
    `}
  }
`

const HeaderContentWrapper = styled.div`
  ${breakpoint('tablet')`
    max-width: 1000px;
    margin: 0 auto;
    border: solid red 10px;
    position: relative;
  `}
`

const HeaderContentBackground = styled.div`
  ${breakpoint('tablet')`
    position: absolute;
    z-index: 9999;
    top: auto;
    left: 0;
    right: 0;
    bottom: 40px;
    background: rgba(0,88,162,.8);
    display:flex;
    flex-drection: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 40px;
  `}
`

const HeadingContainer = styled.div`
  z-index: -1;
  text-align: center;
  padding-top: 111%;
  position: relative;

  ${breakpoint('tablet')`
    padding-top: 0;
    position: static;
    flex: 1;
    text-align: left;
  `}
`

const Heading = styled.h1`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  margin: 0 0 60px;
  font-size: 26px;
  font-weight: 400;
  background: rgba(0, 88, 162, 0.8);
  display: block;
  margin: 0;
  padding: 0.5em 19% 60px;

  ${breakpoint('tablet')`
    position: static;
    background: none;
    padding: 0;
    margin: 0;
    font-size: 3em;
  `}

  ${breakpoint('desktop')`
    margin-top: 100px;
  `}
`

const CardContainer = styled.div`
  width: 100%;
  padding: 0 9% 0 20%;
  box-sizing: border-box;
  margin-top: -52px;
  z-index: 1;

  ${breakpoint('tablet')`
    position: relative;
    background: none;
    padding-bottom: 55%;

    & > img {
      position: absolute;
      right: -28px;
      top: -40px;
    }
  `}
`

const Promesa = styled.div`
  max-width: 62%;
  margin: 10px auto 12px;
  text-align: center;
  font-size: 16px;
  color: rgba(0, 88, 162, 1);

  ${breakpoint('tablet')`
    color: #fff;
    max-width: auto;
  `}
`

const BotonContainer = styled.div`
  text-align: center;
`

const Boton = styled.a`
  display: inline-block;
  background: rgba(0, 88, 162, 1);
  color: #fff;
  padding: 1em 1.6em;
  width: auto;
  margin: 0 auto;
  width: 70%;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 2px;

  ${breakpoint('tablet')`
    background: #fff;
    color: rgba(0,88,162,1);
  `}
`

const RemainingContent = styled.div`
  ${breakpoint('tablet')`
    flex: none;
    width: 350px;
    height: 100%;
  `}
`

const Disclaimer = styled.div`
  max-width: 62%;
  margin: 10px auto;
  text-align: center;
  font-size: 13px;
  ${breakpoint('tablet')`
    flex: none;
    width: 100%;
    text-align: left;
    max-width: 100%;
    margin-top: -2em;
    color: #fff;
    box-sizing: border-box;
  `}
`

const DisclaimerB = styled.a `
    margin-top: 20px;
    color: white;
    font-size: 12px;

`
export default ({
  title,
  disclaimer,
  promesa,
  cta,
  formUrl,
  header_img,
  tarjeta_img,
}) => (
  <HeaderContainer>
    <ImageContainer>
      <picture>
        <source
          media="(max-width: 737px)"
          srcSet={`${header_img}?f=face&fit=fill&w=737&h=820`}
        />
        <source
          media="(max-width: 1024px)"
          srcSet={`${header_img}?f=face&fit=fill&w=1024&h=683`}
        />
        <source
          media="(min-width: 1025px)"
          srcSet={`${header_img}?f=bottom_left&fit=fill&w=1500&h=900`}
        />
        <img
          src={`${header_img}?f=bottom_left&fit=fill&w=1500&h=900`}
          alt={title}
        />
      </picture>
    </ImageContainer>
    <HeaderContentWrapper>
      <HeaderContentBackground>
        <HeadingContainer header_img={header_img}>
          <Heading>{title}</Heading>
        </HeadingContainer>
        <RemainingContent>
          <CardContainer>
            <img src={`${tarjeta_img}?fit=fill&w=590&h=366`} alt={title} />
          </CardContainer>
          <Promesa>{promesa}</Promesa>
          <BotonContainer>
            <Boton href={formUrl}>{cta}</Boton>
            <Boton style={{marginTop:20}} href="http://bit.ly/2AVHMZu">Solicite en Whatsapp</Boton>
            <p><DisclaimerB href=" https://www.baccredomatic.com/es-cr/tarjetas/credito/personas/supermercados-clubes-y-tiendas/pricesmart">Ver condiciones tarjeta Price Cash American Express.</DisclaimerB></p>
          </BotonContainer>
        </RemainingContent>
        <Disclaimer>{disclaimer}</Disclaimer>
      </HeaderContentBackground>
    </HeaderContentWrapper>
  </HeaderContainer>
)
